import { ContainerBlock } from './styles';
import { IBlockProps } from './types';

const Block: React.FC<IBlockProps> = ({ children }) => <ContainerBlock>{children}</ContainerBlock>;

export default Block;
